/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-07-10 11:32:28
 */
export default{
    dealerForm:{
        title:'Werden Sie HEPHA-Händler',
        subTitle:'Wir freuen uns sehr, Sie als HEPHA Händler begrüßen zu dürfen! Dürfen wir Sie bitten, uns einige Informationen zu geben, damit wir Sie als Kunden erstellen können.',
        confirmTip:'Hiermit bestätige ich die Datenschutzbestimmungen der Hepha GmbH und gestatte der HEPHA GmbH ausdrücklich, mich per E-Mail oder telefonisch zu kontaktieren.',
        signDate:'Ort,Datum',
        signName:'Unterschrift', 

        companyName:'Firmenname',
        contactPerson:'Ansprechpartner',
        street:'Straße',
        houseNumber:'Hausnummer',
        zipCode:'Postleitzahl',
        location:'Standort',
        country:'Land',
        city:'Stadt',
        phone:'Telefon',
        mobile:'Mobil',
        email:'E-Mail',
        website:'Website',
        vatNo:'Umsatzsteuernummer',

        storeAddress:'Adresse speichern',
        deliveryAddress:'Lieferadresse',
        salesAreaApprox:'Verkaufsfläche ca.',
        branches:'Zweige',
        serviceWorkshop:'Servicewerkstatt',
        yearOfFoundation:'Gründungsjahr',
        portfolio:'Top 5 Marken in Ihrem Portfolio',
        branchesRemark:'Ja und diese sind:',
        No:'Nein',
        Yes:'Ja',
        ok:'OK',
        cancel:'Abbrechen',
        tip:'Liebevolle Erinnerung',

        submitting:'Absenden, bitte schließen Sie die Seite nicht',
        submit:'Absenden',
        language:'Sprache',
        close:'Schließen',
        empty:'Leere',
        generateImages:'Bilder erzeugen',
        notEmpty:'kann nicht leer sein',
        signConfirm:'Bitte unterschreiben Sie zur Bestätigung',
        pleaseSelect:'Bitte wählen ...',
        submitTip:'Nach der Einreichung kann es nicht geändert werden. ',
        submitTip2:'Bitte bestätigen Sie, ob die ausgefüllten Informationen korrekt sind',
        emailError:'Fehler im E-Mail-Format',
        linkExpired:'Link ist abgelaufen!',
        submitSuccessful:'Erfolgreich Eingereicht!',
        
    }
}